const tryParseJson = (value: string) => {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue;
    } catch (error) {
        return undefined;
    }
};

export default tryParseJson;
